// extracted by mini-css-extract-plugin
export default {"logo":"Score_logo__ey-y1","profile":"Score_profile__e-OZU"};